import ConsultationScheduleViewController from "./consultation-schedule-view-controller";
import { CALENDAR_OPTIONS_FIELD } from "../utils/constants";

class ConsultationSchedulePhoneViewController extends ConsultationScheduleViewController {
  onDemandDisabledChecker() {
    return (
      this.screen.fields &&
      this.screen.fields.findIndex(
        field => field.type === CALENDAR_OPTIONS_FIELD.type
      ) >= 0
    );
  }
}

export default ConsultationSchedulePhoneViewController;
